/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { createApiResponseSchema, type IAPI } from '../../apiResponse';

const saveBookmarkDataSchema = z.object({
  saved: z.boolean(),
});

export interface ISaveBookmarkData {
  saved: boolean;
}

export const saveBookmarkV1ResponseSchema = createApiResponseSchema(
  saveBookmarkDataSchema,
) as z.ZodSchema<IAPI<ISaveBookmarkData>>;

export type ISaveBookmarkV1Response = IAPI<ISaveBookmarkData>;
